import { useEffect, type RefObject } from "react";

export function useIntersectionObserver(ref: RefObject<HTMLElement | null>, toggleClassName: string, options: IntersectionObserverInit = { threshold: [1] }) {
	useEffect(() => {
		if (!ref.current) return;
		const observer = new IntersectionObserver(([entry]) => {
			entry.target.classList.toggle(toggleClassName, entry.intersectionRatio < 1);
		}, options);

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [ref, toggleClassName, options]);
}
